import { GetString } from "fluent-react";
import React, { RefObject } from "react";
import styled from "styled-components";
import { menuBaseColor } from "../../cssVariables";
import { SlideElementProps } from "../../presentationManager/PresentationManager";
import Nav from "../../sharedComponents/NewNav";
import CtaButtons from "./CtaButtons";
import { ContentContainer, Grid, HeaderContainer } from "./Grid";
import Text from "./Text";

//#region Styling
const Root = styled(Grid)`
  padding: 0 5%;
  overflow: auto;
`;

const NavContainer = styled(HeaderContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.75rem;
`;
const AtlasLogoImageContainer = styled.a`
  display: block;
`;
const AtlasLogoImage = styled.img`
  position: relative;
  top: 3px;
  height: 40px;
  min-height: 45px;
`;
//#endregion

interface Props extends SlideElementProps {
  rootZIndex: number;
  getFluentString: GetString;
  countryId: string;
  selectCountry: (country: string) => void;
  year: number;
  goToPrevSlide: () => void;
}

const MainContent = React.forwardRef(
  (props: Props, rootElRef: RefObject<HTMLDivElement>) => {
    const {
      rootZIndex,
      getFluentString,
      countryId,
      selectCountry,
      year,
      goToPrevSlide,
    } = props;
    const style: React.CSSProperties = {
      zIndex: rootZIndex,
    };

    return (
      <Root style={style} ref={rootElRef}>
        <NavContainer>
          <AtlasLogoImageContainer href="/">
            <AtlasLogoImage src={require('../../img/logo-updates-2023/GL_logo_black.png')} />
          </AtlasLogoImageContainer>
          <Nav normalTextColor="white" highlightColor={menuBaseColor} />
        </NavContainer>
        <ContentContainer>
          <Text
            countryId={countryId}
            getFluentString={getFluentString}
            year={year}
            goToPrevSlide={goToPrevSlide}
          />
        </ContentContainer>
        <CtaButtons
          year={year}
          countryId={countryId}
          selectCountry={selectCountry}
          getFluentString={getFluentString}
        />
      </Root>
    );
  }
);

export default MainContent;
